export const PRODUCT_BASE_URL = "https://skcements-files-prod.s3.ap-south-1.amazonaws.com/sk-product-images/";
